import React from 'react';
import css from './css.module.less';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { useDispatch } from 'react-redux';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { OriCheckbox } from '@/src/components/Antd';
import { getI18nFromGeneral } from '@/src/tools/tools';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { useI18n } from 'src/hooks/useRouterChange';
import { generateFooterStyle } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getFooterStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFooterStyleChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/slice';
import { store } from 'src/store';
import { i18nGet } from 'src/tools/tools';
const FooterStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, collapseOpenDefault } = props;
  //console.log('specificError', specificError);
  //
  const {
    backgroundColor,
    textAndIconColor,
    dividerColor,
    displayPaymentMethodLogo,
  } = data || {};
  const _d = useDispatch();
  const handleOnBkgChange = (e) => {
    _d(onFooterStyleChange({ backgroundColor: e }));
  };
  const handleOnTextChange = (e) => {
    _d(onFooterStyleChange({ textAndIconColor: e }));
  };
  const handleOnDividerChange = (e) => {
    _d(onFooterStyleChange({ dividerColor: e }));
  };
  const handleOnLogoDisplayChange = (e) => {
    _d(onFooterStyleChange({ displayPaymentMethodLogo: e.target.checked }));
  };

  return (
    <React.Fragment>
      <Section
        bottomBorder
        className={collapseOpenDefault ? css.fieldSection : ''}>
        <ItemWrapper title={getI18n('general.backgroundColour')}>
          <ColorPicker
            multi
            onChange={handleOnBkgChange}
            color={backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.textIconColour')}>
          <ColorPicker
            multi
            onChange={handleOnTextChange}
            color={textAndIconColor}
          />
        </ItemWrapper>
        <ItemWrapper title={getI18n('salesChannelContent.index.dividerColour')}>
          <ColorPicker
            multi
            onChange={handleOnDividerChange}
            color={dividerColor}
          />
        </ItemWrapper>
      </Section>
      <Section className={css.displayContainer}>
        <OriCheckbox
          checked={displayPaymentMethodLogo}
          onChange={handleOnLogoDisplayChange}>
          {getI18n('salesChannelContent.index.displaypaymentmethodlogos')}
        </OriCheckbox>
      </Section>
    </React.Fragment>
  );
};

export default ErrorProcessingHOC(FooterStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.footerStyle,
  getContent: getFooterStyle,
  title: getI18nFromGeneral('general.hOCTitle.footerStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  getSubmitStamp,
  expandOffset: 0,
  headerProps: {
    //className: css.test,
    dotsFunction: [
      {
        onClick: () => {
          const dD = generateFooterStyle();
          store.dispatch(onFooterStyleChange(dD));
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
